import { makeAutoObservable } from 'mobx';
import guid from '../../../../utils/guid';

export default class Survey {
  id;
  date_created;
  sapId;
  buildingBlockId;
  index;
  last = false;
  finished = false;
  score = 0;

  constructor({
    id = guid(),
    date_created = new Date(),
    sapId = '',
    buildBlockId,
    index,
    last = false,
    finished = false,
    score = 0
  }) {
    this.id = id;
    this.date_created = date_created;
    this.sapId = sapId;
    this.buildingBlockId = buildBlockId;
    this.index = index;
    this.last = last;
    this.finished = finished;
    this.score = score;

    makeAutoObservable(this);
  }

  setFinished(unique_identifier, score) {
    this.finished = true;
    this.sapId = unique_identifier;
    this.score = score || 0;
  }

  static createLocal(sapId, buildingBlockId, index, last = false) {
    const survey = new Survey({
      sapId,
      buildBlockId: buildingBlockId,
      index,
      last
    });
    return survey;
  }
}
